import { colors, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export const UpdateNoteModalStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        outline: "none",
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: "90%",
        overflowY: "auto",
        maxWidth: "95%"
    },
    container: {
        marginTop: theme.spacing(3)
    },
    actions: {
        justifyContent: "flex-end"
    },
    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        "&:hover": {
            backgroundColor: colors.green[900]
        }
    }
}));
